export default __webpack_public_path__ + "static/media/aboutuscropped.621bc554.webm";